const getSecondsOnSite = () => {
  const timeFromDataLayer = window?.dataLayer?.find((entry) => entry['gtm.start'])?.['gtm.start'];
  return timeFromDataLayer ? Math.floor((Date.now() - timeFromDataLayer) / 1000) : -1;
};

const hasVisitedTravelerDetails = () => {
  return window?.dataLayer
    ?.filter((entry) => entry.responsiveUrl)
    .some((entry) => entry.responsiveUrl.includes('traveler-details'));
};

const getPartner = () => {
  return window?.spa_variables?.siteContext?.partner ?? '';
};

const isDefaultStartDate = () => {
  const oneWeekInMilliseconds = 7 * 24 * 60 * 60 * 1000;
  const defaultStartDate = new Date(new Date().getTime() + oneWeekInMilliseconds)
    .toISOString()
    .slice(0, 10);

  return window?.spa_variables?.searchParameters?.startDate === defaultStartDate;
};

const userInfo = () => {
  const timeOnSite = getSecondsOnSite();
  return {
    t: timeOnSite,
    tm: timeOnSite > -1 ? Math.floor(timeOnSite / 60) : -1,
    hl: window?.history?.length,
    td: hasVisitedTravelerDetails() ? 1 : 0,
    p: getPartner(),
    ds: isDefaultStartDate() ? 1 : 0,
  };
};
export default userInfo;
